export function initCountdown() {
    const countdownElement = document.querySelector('.countdown');
    if (!countdownElement) {
        return false;
    }

    const timerElement = countdownElement.querySelector('[data-countdown]');
    if (!timerElement) return false;

    const targetDate = new Date(timerElement.getAttribute('data-countdown')).getTime();

    const daysElement = countdownElement.querySelector('[data-days]');
    const hoursElement = countdownElement.querySelector('[data-hours]');
    const minutesElement = countdownElement.querySelector('[data-minutes]');
    const secondsElement = countdownElement.querySelector('[data-seconds]');

    if (!daysElement || !hoursElement || !minutesElement || !secondsElement) {
        return false;
    }

    function updateCountdown() {
        const now = new Date().getTime();
        const distance = targetDate - now;

        if (distance < 0) {
            // Countdown ist abgelaufen
            daysElement.textContent = '00';
            hoursElement.textContent = '00';
            minutesElement.textContent = '00';
            secondsElement.textContent = '00';
            return;
        }

        // Berechne Tage, Stunden, Minuten, Sekunden
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Update die Anzeige mit führenden Nullen
        daysElement.textContent = days.toString().padStart(2, '0');
        hoursElement.textContent = hours.toString().padStart(2, '0');
        minutesElement.textContent = minutes.toString().padStart(2, '0');
        secondsElement.textContent = seconds.toString().padStart(2, '0');
    }

    // Initiale Berechnung
    updateCountdown();

    // Update jede Sekunde
    const intervalId = setInterval(updateCountdown, 1000);
    
    // Return cleanup function
    return () => {
        clearInterval(intervalId);
    };
}
